import PackageConfig from '#pkg' with { type: 'json' };
import FirebaseConfig from '@yp.nye/config/firebase.json' with { type: 'json' };
import { pick } from '@yp/common/identity.ts';
import { handleClientError } from '@yp/web.app/client/errors.ts';
import { initClient } from '@yp/web.firebase/client/init.ts';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const handleError = handleClientError();

// eslint-disable-next-line @typescript-eslint/naming-convention
export const init = initClient({
  appName: 'nye',
  ...pick(PackageConfig, 'version'),
  emailDomain: 'nye.mcbarron.net',
  firebase: FirebaseConfig.firebase,
});
